export default "__VITE_ASSET__6385333e__"